<template>
    <section container>
        <banner v-if="false"/>

        <section content padding>
            <h1 class="align-center">首页内容</h1>
            <div class="d-block" style="height: 800px;"/>
            <h1 class="align-center">首页内容</h1>
        </section>

        <Contact/>
    </section>
</template>

<script type="text/javascript">
    import Banner from "../../components/Banner";
    import Contact from "../../components/Contact";

    export default {
        components: {
            Banner, Contact,
        },
        data() {
            return {
                planArray: [
                    {
                        icon: 'static/icon/home/plan-video.svg',
                        title: '体育与转播IP化远程制作',
                        desc: '允许主持人、新闻主播和受邀嘉宾在家中或远程工作室参与制作并实时无缝传输',
                        router: '',
                    },
                    {
                        icon: 'static/icon/home/plan-mic.svg',
                        title: '多摄像头远程制作',
                        desc: '减少前往体育和娱乐场所的次数，同时将原始素材传输到中央演播室从而降低成本',
                        router: '',
                    },
                    {
                        icon: 'static/icon/home/plan-cloud.svg',
                        title: '监控和返回源',
                        desc: '为远程人才、导演、色彩师和技术人员提供实时视频流，用于现场应用和后期制作',
                        router: '',
                    },
                    {
                        icon: 'static/icon/home/plan-player.svg',
                        title: '虚拟会议制作',
                        desc: '专业制作在线董事会会议、公司活动、部门会议和小组讨论并实现多终端实时同步传输',
                        router: '',
                    }
                ],
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/home/index.vue